__turbopack_context__.v({
  "frame": "SetupBrandTitle-module__4zhNQq__frame",
  "glyph": "SetupBrandTitle-module__4zhNQq__glyph",
  "latin": "SetupBrandTitle-module__4zhNQq__latin",
  "letter": "SetupBrandTitle-module__4zhNQq__letter",
  "title": "SetupBrandTitle-module__4zhNQq__title",
  "trigger": "SetupBrandTitle-module__4zhNQq__trigger",
});
